import { gql, useQuery } from "@apollo/client";
import { activePromotionsForCustomer, getTipping, myLoyaltyCoupons, myLoyaltyVouchers } from "../../apollo/server";

const GET_DEALS = gql`${activePromotionsForCustomer}`;
const GET_LOYALTY_VOUCHERS = gql`${myLoyaltyVouchers}`;
const GET_LOYALTY_COUPONS = gql`${myLoyaltyCoupons}`;
const TIPPING = gql`${getTipping}`;

/**
 * What the order summary needs besides the cart: deals, rewards, tip options.
 *
 * Checkout runs these the moment it opens, alongside the menu, instead of the
 * summary starting them once the 2-3s menu fetch had finished. Deals are read
 * with the same variables the restaurant page used, so the ones already on
 * screen there appear straight away and refresh underneath.
 */
export default function useSummaryData(restaurantId, stopId = null) {
  const deals = useQuery(GET_DEALS, {
    variables: { restaurantId, stopId },
    skip: !restaurantId,
    fetchPolicy: "cache-and-network",
  });
  const loyalty = useQuery(GET_LOYALTY_VOUCHERS, {
    fetchPolicy: "network-only",
    skip: !restaurantId,
  });
  const loyaltyCoupons = useQuery(GET_LOYALTY_COUPONS, {
    fetchPolicy: "network-only",
  });
  const tips = useQuery(TIPPING, {
    fetchPolicy: "network-only",
  });
  return {
    dealsData: deals.data,
    dealsLoading: deals.loading && !deals.data,
    loyaltyData: loyalty.data,
    loyaltyCouponsData: loyaltyCoupons.data,
    dataTip: tips.data,
  };
}
